import { createRouter, createWebHashHistory } from 'vue-router';
import Login from '@/vue/UserLogin.vue';
import DashBoard from '@/vue/DashBoard.vue';
import GroupRegist from '@/vue/GroupRegist.vue';
import GroupEdit from '@/vue/GroupEdit.vue';
import DamageMap from '@/vue/DamageMap.vue';
import DamageList from '@/vue/DamageList.vue';
import DamageDetail from '@/vue/DamageDetail.vue';
import DamageEdit from '@/vue/DamageEdit.vue';
import MeasureList from '@/vue/MeasureList.vue';
import MeasureDetail from '@/vue/MeasureDetail.vue';
import MeasureEdit from '@/vue/MeasureEdit.vue';
import UserRegist from '@/vue/UserRegist.vue';
import UserEdit from '@/vue/UserEdit.vue';
import UserInfo from '@/vue/UserInfo.vue';
const URL = process.env.VUE_APP_URN;
//const URL = '';

const routes = [
  {
    path: `${URL}/`,
    name: 'Login',
    component: Login,
    meta: {
      title: 'MIELOUPE(WEB)ログイン'
    }
  },
  {
    path: `${URL}/Home`,
    name: 'Home',
    component: DashBoard,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
     }
  },
  {
    path: `${URL}/DamageMap`,
    name: 'DamageMap',
    component: DamageMap,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
    }
  },
  {
    path: `${URL}/GroupEdit`,
    name: 'GroupEdit',
    component: GroupEdit,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
    }
  },
  {
    path: `${URL}/GroupRegist`,
    name: 'GroupRegist',
    component: GroupRegist,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
    }
  },
  {
    path: `${URL}/DamageList`,
    name: 'DamageList',
    component: DamageList,
    meta: { requiresAuth: true,
             title: 'MIELOUPE'
     }
  }, 
  {
    path: `${URL}/DamageDetail`,
    name: 'DamageDetail',
    component: DamageDetail,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  },
  {
    path: `${URL}/DamageEdit`,
    name: 'DamageEdit',
    component: DamageEdit,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  },
  {
    path: `${URL}/MeasureList`,
    name: 'MeasureList',
    component: MeasureList,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  },  
  {
    path: `${URL}/MeasureDetail`,
    name: 'MeasureDetail',
    component: MeasureDetail,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  }, 
  {
    path: `${URL}/MeasureEdit`,
    name: 'MeasureEdit',
    component: MeasureEdit,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  },
  {
    path: `${URL}/UserInfo`,
    name: 'UserInfo',
    component: UserInfo,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  },
  {
    path: `${URL}/UserRegist`,
    name: 'UserRegist',
    component: UserRegist,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  },
  {
    path: `${URL}/UserEdit`,
    name: 'UserEdit',
    component: UserEdit,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// ルートガードを追加して認証チェック
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('jwtToken') !== null;

  // ページタイトルを設定
  router.afterEach((to, from) => {
    document.title = to.meta.title
  })

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next(`${URL}/`);
  } else {
    next();
  }
});

export default router;
